<template>
    <div class="invite">
        <div class="page-header header-fixed">
            <div class="container">
                <header>
                    <h1 v-if="coach">
                        <template>{{ __('Edit dietitian details') }}</template>
                        {{
                            __('(step :step out of :steps)', {
                                step: 1,
                                steps: 2
                            })
                        }}
                    </h1>
                    <h1 v-else>{{ __('New dietitian') }} {{ __('(step :step out of :steps)', { step: 1, steps: 2 }) }}</h1>
                </header>
                <div class="header-buttons">
                    <input v-model="form.user_id" name="user_id" type="hidden" />
                    <VButton v-if="coach" :href="'/terapeut/'+coach.id" :label="__('Back')" size="sm" variant="secondary" />
                    <VButton v-else :label="__('Back')" href="/terapeute" size="sm" variant="secondary" />
                    <VButton :label="__('Continue')" type="submit" size="sm" @onClick="submit" />
                </div>
            </div>
        </div>
        <section class="profile-wrapper">
            <form id="form-step-one" action="#" @submit.prevent="nextStep">
                <h2>{{ __('Basic information about the dietitian') }}</h2>
                <FormInputTypeAvatarImageSelect :current-image="$_.get(coach, 'user.avatar')" name="avatar" />

                <form-input-type-radio
                    :options="[
                        { value: 'f', label: __('Woman') },
                        { value: 'm', label: __('Man') }
                    ]"
                    :value="form.sex"
                    margin-bottom-double
                    name="sex"
                    required
                />

                <form-input-type-text
                    :errors="errors.name"
                    :label="__('First name')"
                    :value="form.name"
                    margin-bottom-double
                    name="name"
                    required
                ></form-input-type-text>

                <form-input-type-text
                    :errors="errors.surname"
                    :label="__('Last name')"
                    :value="form.surname"
                    margin-bottom-double
                    name="surname"
                    required
                ></form-input-type-text>

                <form-input-type-email
                    :errors="errors.email"
                    :label="__('E-mail')"
                    :value="form.email"
                    margin-bottom-double
                    name="email"
                    required
                ></form-input-type-email>

                <form-input-type-phone-number
                    name="phone"
                    :label="__('Phone number')"
                    :phone-country="form.phone_country"
                    :value="form.phone"
                    :errors="errors.phone"
                    margin-bottom-double
                    required
                ></form-input-type-phone-number>

                <form-input-type-text-area
                    v-if="!form.video_link"
                    :errors="errors.video_link"
                    :label="__('Video link (link to video)')"
                    :value="form.video_link"
                    margin-bottom-double
                    name="video_link"
                />

                <form-input-type-text-area
                    :errors="errors.welcome_msg"
                    :label="__('Introductory message to the patient chat')"
                    :value="form.welcome_msg"
                    auto-grow
                    margin-bottom-double
                    name="welcome_msg"
                    required
                />

                <form-input-type-text-area
                    :errors="errors.welcome_msg_no_consult"
                    :label="__('Introductory chat message without consultation')"
                    :value="form.welcome_msg_no_consult"
                    auto-grow
                    margin-bottom-double
                    name="welcome_msg_no_consult"
                    required
                />

                <form-input-type-text-area
                    :errors="errors.for_doctors"
                    :label="__('Information about the dietitian for doctors')"
                    :value="form.for_doctors"
                    auto-grow
                    margin-bottom-double
                    name="for_doctors"
                    required
                />

                <input v-model="form.user_id" name="user_id" type="hidden" />
            </form>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        coach: {
            type: Object,
            required: false,
            default() {
                return {}
            }
        },
        errors: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            form: {
                name: _.get(this.coach, 'user.name', ''),
                surname: _.get(this.coach, 'user.surname', ''),
                sex: _.get(this.coach, 'user.sex', 'f'),
                email: _.get(this.coach, 'user.email', ''),
                phone_country: _.get(this.coach, 'user.phone_country_raw') || '',
                phone: _.get(this.coach, 'user.phone_raw', ''),
                video_link: _.get(this.coach, 'video_link', ''),
                welcome_msg: _.get(this.coach, 'welcome_msg', ''),
                welcome_msg_no_consult: _.get(this.coach, 'welcome_msg_no_consult', ''),
                for_doctors: _.get(this.coach, 'for_doctors', ''),
                user_id: _.get(this.coach, 'user_id', '')
            }
        }
    },
    async mounted() {
        $(() => {
            const textareaWelcomeMsgNoConsult = $('#welcome_msg_no_consult')[0]
            textareaWelcomeMsgNoConsult.style.height = (textareaWelcomeMsgNoConsult.scrollHeight) + 'px'

            const textareaForDoctors = $('#for_doctors')[0]
            textareaForDoctors.style.height = (textareaForDoctors.scrollHeight) + 'px'

            const textareaWelcomeMsg = $('#welcome_msg')[0]
            textareaWelcomeMsg.style.height = (textareaWelcomeMsg.scrollHeight) + 'px'
        })
    },
    computed: {
        getPhoneCountry() {
            if(_.get(this.coach, 'user.phone_country_raw')) {
                return _.get(this.coach, 'user.phone_country_raw')
            } else {
                return this.user.locale
            }
        }
    },
    methods: {
        // goBack() {
        //     return window.history.go(-1)
        // },
        submit() {
            const data = new FormData(document.getElementById('form-step-one'))

            // Validate form then proceed to the next step
            this.$emit('step', { data, nextStep: 2 })
        }
    }
}
</script>
